// extracted by mini-css-extract-plugin
export default {"Popup":"MainMap_Popup__U3SBJ","Attribute":"MainMap_Attribute__K02bM","mapContainer":"MainMap_mapContainer__9J7zG","map":"MainMap_map__MgWlJ","warn":"MainMap_warn__WgiB0"};